import { connect } from 'react-redux';
import PagesView from './index'
import {removePage, loadPages, updatePage} from '../../actions/Pages'


const mapStateToProps = (state, props) => {
    
    return {
	pages: state.pages.list
    }
}

const mapDispatchToProps = (dispatch, state) => {
    return {
	loadPages: () => {
	    return dispatch(loadPages());
	},
	removePage: (id) => {
	    return dispatch(removePage(id)).then(() => dispatch(loadPages()));
	},
	updatePage: (page) => {
	    return dispatch(updatePage(page)).then(() => dispatch(loadPages()));
	}
    }
}

const PagesContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PagesView);




export default PagesContainer;



// WEBPACK FOOTER //
// ./src/components/Pages/Container.js